/**
 * Приведение адреса к виду, пригодному для аналитики.
 *
 * Две задачи, и обе обязательные.
 *
 * 1. ⚠️ БЕЗОПАСНОСТЬ. В адресах приложения ездят секреты и персданные:
 *    `/invite/<токен>`, `/q/<токен>` (публичная смета), `/e/<токен>`
 *    (паспорт оборудования), `/amc/<токен>`, `?token=` на приглашении в Сейф,
 *    `?email=` на логине и регистрации. Пейджвью уходит третьей стороне —
 *    отправить туда сырой URL значит отдать Яндексу одноразовые ссылки и
 *    почту пользователей. Вырезаем до отправки, а не «потом почистим».
 *    (Хендофф-код сюда не попадает: он живёт во фрагменте, а фрагмент мы не
 *    берём вовсе — см. sessionHandoff.js.)
 *
 * 2. ЧИТАЕМОСТЬ. Без нормализации id отчёт «Страницы» распухает в тысячи
 *    уникальных адресов вида /properties/417, и понять, какие экраны вообще
 *    смотрят, становится невозможно. `/properties/:id` — одна строка отчёта.
 */

// Роуты, где второй сегмент — одноразовый токен, а не идентификатор.
const TOKEN_ROUTES = new Set(['invite', 'q', 'e', 'amc']);

// Параметры, которых не должно быть в аналитике ни при каких обстоятельствах.
const STRIP_PARAMS = ['token', 'email', 'code', 'handoff', 'password'];

function sanitizePath(pathname) {
  const parts = pathname.split('/');

  return parts
    .map((part, i) => {
      if (!part) return part;
      // /invite/<токен> → /invite/:token
      if (i === 2 && TOKEN_ROUTES.has(parts[1])) return ':token';
      // /properties/417 → /properties/:id
      if (/^\d+$/.test(part)) return ':id';
      return part;
    })
    .join('/');
}

function sanitizeSearch(search) {
  if (!search) return '';

  const params = new URLSearchParams(search);
  STRIP_PARAMS.forEach((p) => params.delete(p));

  const rest = params.toString();
  return rest ? `?${rest}` : '';
}

/**
 * @param {string} pathname — из useLocation()
 * @param {string} search   — из useLocation()
 * @returns {string} абсолютный URL, безопасный для отправки в аналитику
 */
export function analyticsUrl(pathname, search) {
  return window.location.origin + sanitizePath(pathname) + sanitizeSearch(search);
}
